module.exports = __webpack_public_path__ + "assets/img/AuditCover.d24e3e5d.webp";